const STYLE = {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1440,
  },
};

export const largeScreenMinWidth = 1920;
export const mobileScreenType = "mobile";
export const tabletScreenType = "tablet";
export const desktopScreenType = "desktop";
export const largeDisplayScreenType = "largeDisplay";

export const MAX_WIDTH = {
  [mobileScreenType]: "767px",
  [tabletScreenType]: "991px",
  [desktopScreenType]: "1900px",
};

export const SIZES = [
  mobileScreenType,
  tabletScreenType,
  desktopScreenType,
  largeDisplayScreenType,
];

const SCREENS = {
  FULL_SCREEN: "full",
  WIDE_SCREEN: "wide",
  NARROW_SCREEN: "narrow",
  SCREEN_1200: "screen-1200",
  SCREEN_900: "screen-900",
};

export const { FULL_SCREEN, WIDE_SCREEN, NARROW_SCREEN, SCREEN_1200, SCREEN_900 } = SCREENS;

export const { breakpoints } = STYLE;
export default STYLE;
